export default __webpack_public_path__ + "static/media/news5.405fa84a.jpg";